import { render } from "./TheFooter.vue?vue&type=template&id=42ca5c2e&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=42ca5c2e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Development\\saska-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ca5c2e"]])

export default __exports__